import { gql } from '@apollo/client';

export const PLAYER_FIELDS = gql`
  fragment PlayerFields on Player {
    _id
    firstName
    lastName
    nickname
    dateOfBirth
    gender
    externalId
    handedness
    primarySport
  }
`;

export const PLAYER_MILESTONE_FIELDS = gql`
  fragment PlayerMilestoneFields on PlayerMilestone {
    _id
    type
    value
    recordedAt
  }
`;

// Token-bearing contacts (public edit page) have no signed-in user to key the offline buffer on, so their player
// edits submit directly here; staff edits buffer and go through RECORD_USER_SESSION.
export const RECORD_TOKEN_PLAYER_SESSION = gql`
  mutation RecordTokenPlayerSession($startedAt: Date!, $token: String!, $playerAssessmentId: ID!, $actions: [JSONObject!]!) {
    recordTokenUserSession(startedAt: $startedAt, token: $token, playerAssessmentId: $playerAssessmentId, actions: $actions) {
      actionType
      loggedAt
      status
      succeeded
      refusalReason
    }
  }
`;

// Token-gated read of the player behind the public edit page. The `code` alone
// is not authorization (it sits in the public URL); the player-scoped token is
// what the server verifies against the player resolved from the code.
export const GET_PUBLIC_EDIT_PLAYER = gql`
  query GetPublicEditPlayer($code: String!, $token: String) {
    player(code: $code, token: $token) {
      ...PlayerFields
      milestones {
        ...PlayerMilestoneFields
      }
    }
  }

  ${PLAYER_FIELDS}
  ${PLAYER_MILESTONE_FIELDS}
`;

